var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6941 18.2471L14.6706 13.2235C15.7529 11.8353 16.4 10.0941 16.4 8.2C16.4 3.67059 12.7294 0 8.2 0C3.67059 0 0 3.67059 0 8.2C0 12.7294 3.67059 16.4 8.2 16.4C10.0941 16.4 11.8353 15.7529 13.2235 14.6706L18.2471 19.6941C18.6471 20.0941 19.2941 20.0941 19.6941 19.6941C20.0941 19.2941 20.0941 18.6471 19.6941 18.2471ZM8.2 14.3647C4.8 14.3647 2.04706 11.6118 2.04706 8.21176C2.04706 4.81176 4.81176 2.04706 8.2 2.04706C11.5882 2.04706 14.3529 4.8 14.3529 8.2C14.3529 11.6 11.6 14.3529 8.2 14.3529V14.3647Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.8a0cf591bea5d567a0906402181e339c.svg";
export { ForwardRef as ReactComponent };